import { motion } from "framer-motion";
import Icon from "../Icon";
import { Reveal } from "../Reveal";
import { REPUTATION } from "../../data";

export default function ReputationSpotlight() {
  return (
    <div className="grid items-center gap-12 lg:grid-cols-2">
      <Reveal>
        <div className="relative">
          <div className="pointer-events-none absolute -inset-6 rounded-[2rem] bg-blue-600/10 blur-3xl" />
          <div className="relative overflow-hidden rounded-3xl border border-white/10">
            <img
              src="https://images.pexels.com/photos/33438842/pexels-photo-33438842.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000"
              alt="Micro-celebrity reputation management"
              className="h-[460px] w-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 flex items-center gap-3 rounded-2xl border border-white/10 bg-black/40 px-4 py-3 backdrop-blur-xl">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-600/20 text-blue-400">
                <Icon name="Star" className="h-4 w-4" />
              </div>
              <p className="text-sm font-medium text-white">Trusted profile management</p>
            </div>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">{REPUTATION.overline}</p>
          <h2 className="mt-4 font-display text-3xl font-medium tracking-tight sm:text-4xl">{REPUTATION.title}</h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-400">{REPUTATION.desc}</p>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {REPUTATION.points.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.06}>
              <motion.div
                whileHover={{ y: -4 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-5 backdrop-blur-xl transition-colors duration-300 hover:border-blue-500/40"
                data-testid={`reputation-point-${i}`}
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-600/15 text-blue-400">
                  <Icon name={p.icon} className="h-5 w-5" />
                </div>
                <h3 className="mt-4 font-display text-lg font-medium tracking-tight">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{p.text}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
